interface ArrowsCarouselProps {
  className?: string
  onClick?: () => void
  style?: React.CSSProperties
}

export const NextArrow = (props: ArrowsCarouselProps) => {
  const { className, style, onClick } = props
  return (
    <div
      className="absolute bottom-[10px] md:bottom-[20px] right-3 cursor-pointer z-[20]"
      onClick={onClick}
    >
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="14" cy="14" r="14" fill="#FFF" />
        <path
          d="M12 20L17 14.0596L12 8"
          stroke="#181818"
          strokeWidth="0.975881"
        />
      </svg>
    </div>
  )
}

export const PrevArrow = (props: ArrowsCarouselProps) => {
  const { className, style, onClick } = props
  return (
    <div
      className="absolute bottom-[10px] md:bottom-[20px] left-3 cursor-pointer z-[20]"
      onClick={onClick}
    >
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="14"
          cy="14"
          r="14"
          transform="matrix(-1 0 0 1 28 0)"
          fill="#FFF"
        />
        <path
          d="M16 20L11 14.0596L16 8"
          stroke="#181818"
          strokeWidth="0.966534"
        />
      </svg>
    </div>
  )
}
